"use client";

import { useEffect, useMemo } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Partners from "./pages/Partners";
import Contact from "./pages/Contact";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
function ScrollToHash() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const el = document.querySelector(hash);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [hash]);
  return null;
}
function SEOUpdater() {
  const { pathname } = useLocation();
  useEffect(() => {
    const titles = {
      "/": "Home - Faef Global",
      "/about": "About Us - Faef Global",
      "/services": "Our Services - Faef Global",
      "/partners": "Partner Program - Faef Global",
      "/contact": "Contact Us - Faef Global ",
    };
    const descriptions = {
      "/": "Your trusted global telecommunications partner, connecting businesses worldwide with reliable, scalable communication solutions.",
      "/about":
        "Learn about Faef Global's mission to provide world-class telecommunications infrastructure for global business communications.",
      "/services":
        "Comprehensive telecommunications solutions including voice connectivity, messaging, global interconnects, and network analytics.",
      "/partners":
        "Join Faef Global's partner program for telecom carriers, enterprises, and technology partners worldwide.",
      "/contact":
        "Contact Faef Global for your telecommunications needs. Sales, support, and partnerships.",
    };
    document.title = titles[pathname] || "Faef Global";
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = descriptions[pathname] || descriptions["/"];
  }, [pathname]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const pathFromKey = {
    home: "/",
    about: "/about",
    services: "/services",
    partners: "/partners",
    contact: "/contact",
  };
  const keyFromPath = useMemo(() => {
    const map = {
      "/": "home",
      "/about": "about",
      "/services": "services",
      "/partners": "partners",
      "/contact": "contact",
    };
    return map[pathname] || "home";
  }, [pathname]);

  // Keep old onNavigate prop working
  const onNavigate = (pageOrPath) => {
    const to = pageOrPath?.startsWith?.("/")
      ? pageOrPath
      : pathFromKey[pageOrPath] || "/";
    navigate(to);
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOUpdater />
      <ScrollToTop />
      <ScrollToHash />

      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 bg-primary-600 text-white px-4 py-2 rounded-md z-50">
        Skip to main content
      </a>

      <Navbar currentPage={keyFromPath} onNavigate={onNavigate} />

      <main id="main-content" role="main">
        <Routes>
          <Route path="/" element={<Home onNavigate={onNavigate} />} />
          <Route path="/about" element={<About onNavigate={onNavigate} />} />
          <Route
            path="/services"
            element={<Services onNavigate={onNavigate} />}
          />
          <Route
            path="/partners"
            element={<Partners onNavigate={onNavigate} />}
          />
          <Route
            path="/contact"
            element={<Contact onNavigate={onNavigate} />}
          />
        </Routes>
      </main>

      <Footer onNavigate={onNavigate} />
    </div>
  );
}

export default function App() {
  return <Shell />;
}
